// extracted by mini-css-extract-plugin
module.exports = {"timeout":"Timeout_timeout__3UQya"};